import { useSetRecoilState } from "recoil"

import { ConsoleLogger } from "../util/logger"
import { roomSelector } from "../recoil/atoms/room"
import { SDKResponse, RoomEventResponse } from "./types"
import { joinErrorMessageAtom } from "../recoil/atoms/error"
import { joinButtonLoadingSelector } from "../recoil/atoms/joinButton"

interface AuthEventsCBProps {
  onSuccess: (response: RoomEventResponse) => void
  onFail: (response: SDKResponse) => void
}

const logger = new ConsoleLogger()

export const useAuthEventsCB = (): AuthEventsCBProps => {
  const setRoom = useSetRecoilState(roomSelector)
  const setJoinButtonLoading = useSetRecoilState(joinButtonLoadingSelector)
  const setJoinError = useSetRecoilState(joinErrorMessageAtom)

  const handleAuthOnSuccess = async (response: RoomEventResponse) => {
    logger.log("CB----a1----", response)

    //  setRoom({ name: "UPDATE", attributes: {...response.room, enableShoppableVideos: true }})
    setRoom({ name: "UPDATE", attributes: response.room })
  }

  const handleAuthOnFail = (response: SDKResponse) => {
    logger.log("CB----a2----", response)
    setJoinButtonLoading(false)
    setJoinError({ message: response.message, code: response.code })
  }

  return {
    onSuccess: handleAuthOnSuccess,
    onFail: handleAuthOnFail
  }
}
